export default (() => {
    function sendSingleItemToGA (item) {
        const requiredParameters = ['category', 'action', 'label', 'value'];
        const areParametersDefined = _getWhetherParametersAreDefined(item, requiredParameters);
        const isGAInitialised = _getWhetherGAIsInitialised();

        if (!areParametersDefined) {
            return wealthify.error.throwError('wealthify.analytics', `${requiredParameters.join(', ')} must be defined.`);
        }

        if (!isGAInitialised) {
            return wealthify.error.throwError('wealthify.analytics', 'Google Analytics is not yet initialised.');
        }
        
        window.wfy_ga.triggerEvent(item.category, item.action, item.label, item.value);
    }

    function sendMultipleItemsToGA (data) {
        const requiredParameters = ['category', 'action', 'items'];
        const areParametersDefined = _getWhetherParametersAreDefined(data, requiredParameters);

        if (!areParametersDefined) {
            return wealthify.error.throwError('wealthify.analytics', `${requiredParameters.join(', ')} must be defined.`);
        }

        Object.keys(data.items).forEach((key) => {
            sendSingleItemToGA({
                category: data.category,
                action: data.action,
                label: key,
                value: data.items[key]
            });
        });
    }

    function _getWhetherGAIsInitialised () {
        return window.wfy_ga !== null;
    }

    function _getWhetherParametersAreDefined (item, requiredParameters) {        
        return requiredParameters.every((requiredProperty) => item[requiredProperty] !== undefined);
    }

    return {
        sendSingleItemToGA,
        sendMultipleItemsToGA
    };

})();